import styled from 'styled-components/macro'

export const Svg = styled.svg`
  display: inline-block;
  width: 1em;
`
